var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.content, placement: 'left', offset: 10 }),expression:"{ content, placement: 'left', offset: 10 }"}],staticClass:"employee-leave-info-button",attrs:{"type":"button","aria-label":_vm.accessibleLabel}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("i")])])
}
var staticRenderFns = []

export { render, staticRenderFns }